import YupBuilder from '@/modules/builder/classes/builders/yup-builder/YupBuilder'

export default YupBuilder
